<mat-card>
  <mat-card-content>
    <h3>Refund Filter</h3>
    <form [formGroup]="refundSearchForm" class="margin-top-med">
      <div class="flex-row-wrap justify-space-between align-center">
        <mat-form-field class="flex-33" appearance="outline">
          <mat-label>Charge ID</mat-label>
          <input matInput placeholder="enter charge id" formControlName="chargeId" data-testid="charge-id-input">
          <mat-hint>enter entire or part of charge id</mat-hint>
        </mat-form-field>
        <mat-form-field class="flex-33" appearance="outline">
          <mat-label>Refund ID</mat-label>
          <input matInput placeholder="enter refund id" formControlName="refundId" data-testid="refund-id-input">
          <mat-hint>enter entire or part of refund id</mat-hint>
        </mat-form-field>
        <mat-form-field class="flex-33" appearance="outline">
          <mat-label>Refund Date</mat-label>
          <input placeholder="filter by transaction date" matInput [matDatepicker]="picker"
                 formControlName="refundDate" data-testid="refund-date-input">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-hint>YYYY-MM-DD</mat-hint>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="text-end margin-bottom-med margin-top-med">
        <button matTooltip="search players" [disabled]="!refundSearchForm.valid" mat-raised-button type="submit"
                color="primary" class="margin-right-small" (click)="onFormSubmit()"
                data-testid="search-players-button">Filter
          <mat-icon>search</mat-icon>
        </button>
        <button matTooltip="reset filters" mat-raised-button color="warn" (click)="onResetClick()"
                data-testid="reset-players-button">Reset
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </form>
    <h3>Refunds</h3>
    <ag-grid-angular
      id="playerRefundsGrid"
      class="ag-theme-quartz margin-top-med large-table"
      data-testid="player-refund-table"
      [tooltipShowDelay]=0
      rowClass="table-row"
      domLayout="autoHeight"
      overlayNoRowsTemplate="<span>Player has no refunds for this game.</span>"
      (gridReady)="onTransactionGridReady($event)"
      [rowData]="filteredRefunds"
      [pagination]="true"
      [columnDefs]="refundColumnDefs">
    </ag-grid-angular>

  </mat-card-content>
</mat-card>
